import React from 'react';
import { IconProps } from '.';

const SvgZigzagWeb = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#FFD1E9' d='M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z' />
      <path
        fill='#FFC2E1'
        fillRule='evenodd'
        d='M19 3.5H5A1.5 1.5 0 0 0 3.5 5v14A1.5 1.5 0 0 0 5 20.5h14a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 19 3.5ZM5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Z'
        clipRule='evenodd'
      />
      <path
        fill='#FF349C'
        d='M8.117 16.5h2.514l1.376-5.545h.04l1.322 5.545h2.5L18 7.5h-2.17l-1.244 5.665h-.04L13.145 7.5h-2.01l-1.416 5.665h-.053L8.5 7.5H6l2.117 9Z'
      />
    </svg>
  );
};

export default SvgZigzagWeb;
